import getVWKey from "../helpers/getVWKey";

function initCameraLimits({ data, controls: { orbit: orbitControls, FPS: fpsControls, objectRotation: objectRotationControls } }) {
    const currentCameraLimits = data.slides[0].cameraLimits;
    const vpType = getVWKey();
    const cameraLimits = vpType === "sizeSm" && currentCameraLimits[vpType]
        ? currentCameraLimits[vpType]
        : currentCameraLimits;

    if (cameraLimits.zoomLimitEnabled) {
        orbitControls.minDistance = cameraLimits.minDistance;
        orbitControls.maxDistance = cameraLimits.maxDistance;
    }

    if (cameraLimits.horizontalAngleLimitEnabled) {
        orbitControls.minAzimuthAngle = cameraLimits.minAzimuthAngle * THREE.Math.DEG2RAD;
        orbitControls.maxAzimuthAngle = cameraLimits.maxAzimuthAngle * THREE.Math.DEG2RAD;
    }

    if (cameraLimits.verticalAngleLimitEnabled) {
        orbitControls.minPolarAngle = cameraLimits.minPolarAngle * THREE.Math.DEG2RAD;
        orbitControls.maxPolarAngle = cameraLimits.maxPolarAngle * THREE.Math.DEG2RAD;
    }

    if (cameraLimits.panLimitEnabled) {
        let { center, quaternion, offset } = cameraLimits.panLimits;
        orbitControls.setPanLimits(center, quaternion, offset);
    } else {
        orbitControls.setPanLimits();
    }

    const controls = data.slides[0].controls;
    if (controls && controls.interactionType) {
        let { interactionType, objectRotationMode } = controls.interactionType;

        if (interactionType !== 'orbit') {
            orbitControls.enabled = false;

            switch (interactionType) {
                case 'FPS':
                    fpsControls.activate();
                    break;
                case 'objectRotation':
                    objectRotationControls.enabled = true;
                    break;
            }
        }

        if (objectRotationMode) {
            objectRotationControls.rotationMode = objectRotationMode;
        }
    }
}

export default initCameraLimits;
export { initCameraLimits };